/**
 * App — route table and global UI chrome (loading spinner, error/message
 * banners). Auth pages are public; everything under "/" renders inside
 * PrivateRoute, which requires a session and wraps pages in MainLayout.
 */
import React from "react";
import { Spin } from "antd";
import { Route, Routes } from "react-router-dom";
import {
  SignInPage,
  ForgotPasswordPage,
  ResetPasswordPage,
  LogoutPage,
  E404Page,
  DashboardPage,
  ZonesPage,
  SettingsPage,
  ZonesDetailsPage,
} from "components/Pages";

import AppError from "./AppError";
import AppMessage from "./AppMessage";
import PrivateRoute from "./PrivateRoute";
import StagingBanner from "./StagingBanner";

import { useSelector } from "react-redux";

const App = () => {
  const common = useSelector((state) => state.common);
  const globalLoading = common.globalLoading;

  return (
    <Spin spinning={globalLoading} wrapperClassName="wrap-spin">
      <StagingBanner />
      <AppError />
      <AppMessage />
      <Routes>
        <Route exact path="/login" element={<SignInPage />} />
        {/* GF-38: /register is gone. The backend endpoint is still open — it is
            only held shut by an nginx basic-auth stopgap added 2026-09-11 — and
            the form here could not work anyway: the stopgap's 401 fails the CORS
            preflight, so the request never leaves the browser and the page shows
            a network error with no explanation (measured in staging 2026-09-15).
            Accounts are created with scripts/New-GeoFixUser.ps1 until real user
            administration exists; SignUpPage and its form are left in the tree
            for that work to build on. */}
        <Route exact path="/forgot-password" element={<ForgotPasswordPage />} />
        <Route exact path="/reset-password" element={<ResetPasswordPage />} />
        <Route exact path="/logout" element={<LogoutPage />} />
        <Route path="/" element={<PrivateRoute allowedRoles={['user', 'admin']} />} >
          <Route path="/" element={<DashboardPage />} />
          <Route path="/zones" element={<ZonesPage />} />
          <Route path="/zones/:id" element={<ZonesDetailsPage />} />
          <Route path="/settings" element={<SettingsPage />} />
        </Route>
        <Route path="/*" element={<E404Page />} />
      </Routes>
    </Spin>
  );
};
export default App;
